export enum AgreementType {
    Platform = 'Platform Terms & Conditions',
    Membership = 'Membership Terms & Conditions',
    Privacy = 'Privacy Policy',
    Medical = 'Medical Check',
    Home = 'Home Training – Membership T&C',
    Consolidated = 'https://studios.fitillion.com/all-terms-and-conditions/',
}

const agreementVersionConfig = {
    [AgreementType.Privacy]: '1.0.0',
    [AgreementType.Platform]: '1.0.0',
    [AgreementType.Membership]: '1.0.0',
    [AgreementType.Medical]: '1.0.0',
    [AgreementType.Home]: '1.0.0',
    [AgreementType.Consolidated]: '1.0.0',
};

export class LegalAgreement {
    public static createSignedInstance(agreementType: AgreementType): LegalAgreement {
        const agreement = new LegalAgreement();
        agreement.agreementVersion = agreementVersionConfig[agreementType];
        agreement.agreement = agreementType;
        agreement.dateOfAcceptance = new Date().toISOString();
        return agreement;
    }

    public static createSignedInstances(agreementTypes: AgreementType[]): LegalAgreement[] {
        return agreementTypes.map(
          (agreementType) => LegalAgreement.createSignedInstance(agreementType),
        );
    }

    public static mergeLegalAgreements(
      previousAgreements: LegalAgreement[] | undefined, // undefined when building new user profile
      newAgreements: LegalAgreement[],
    ): LegalAgreement[] {
        if (previousAgreements === undefined) {
            return newAgreements;
        }

        const agreementsNotAlreadyAccepted = newAgreements
          .filter((newAgreement: LegalAgreement) => {
              const foundInPrevious = previousAgreements
                // TODO: eventually this should check on the version as well
                .find((previous) => previous.agreement === newAgreement.agreement);
              return !foundInPrevious;
          });

        return previousAgreements.concat(agreementsNotAlreadyAccepted);
    }

    public static validAgreementTypeList(agreements: any): agreements is AgreementType[] {
        if (!Array.isArray(agreements)) {
            return false;
        }
        return agreements.every((agreement) => Object.values(AgreementType).includes(agreement));
    }

    public agreement: AgreementType;
    public dateOfAcceptance: string;
    public agreementVersion: string;
}
